import { createUseStyles } from "react-jss";
import { resolveChoiceRadioIconSizeModern } from "../../theme/choiceThemeTokens";
import type { Theme } from "../../types/Theme";

export default createUseStyles({
    radioIcon: {
        composes: "radio__icon",
        verticalAlign: "middle",
        display: "inline-flex",
        alignItems: "center",
        fontSize: ({ theme }: { theme: Theme }) =>
            theme.UseModernTheme === true ? resolveChoiceRadioIconSizeModern(theme) : 23,
        pointerEvents: "none",
        "& .custom__Image": {
            "max-height": "100%",
        },
    },
    radioIconChecked: {
        composes: "radio__icon--checked",
    },
    radioIconDisabled: {
        composes: "radio__icon--disabled",
        opacity: 0.5,
    },
});
